import LegalDocumentPage, { Section, SectionTitle } from '../components/LegalDocumentPage';
import { LEGAL, LEGAL_ROUTES } from '../data/legalContent';

const Contact = () => (
  <LegalDocumentPage
    title="Contact"
    description="Contact FounderDNA for support and privacy requests."
    path={LEGAL_ROUTES.contact}
    lastUpdated={LEGAL.lastUpdated}
  >
    <Section>
      <p>
        {LEGAL.siteName} is operated as an independent product at{' '}
        <a href={LEGAL.siteUrl}>{LEGAL.siteUrl}</a>. For support or general questions, use the email below.
      </p>
    </Section>

    <Section>
      <SectionTitle>General contact</SectionTitle>
      <p>
        Product questions and support:{' '}
        <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>
      </p>
    </Section>

    <Section>
      <SectionTitle>Privacy requests</SectionTitle>
      <p>
        For access, correction, deletion, or portability requests, email{' '}
        <a href={`mailto:${LEGAL.privacyEmail}`}>{LEGAL.privacyEmail}</a> with the subject line{' '}
        <strong>Privacy request</strong>. We respond within a reasonable time where required by law.
      </p>
      <p>
        To delete data stored only on your device, use <strong>Delete all local data</strong> in your
        results report under Share &amp; save, or clear site data in your browser.
      </p>
    </Section>
  </LegalDocumentPage>
);

export default Contact;
